<div [class.has-location]="!!data?.locationSummary" [class.has-design-context]="!!data?.map_feature_link" class="wrapper">
  <div class="description text-type-10">{{ data?.title }}</div>
  @if (data?.type) {
    <div class="category text-type-14 mt-[10px]">{{ data?.type }}</div>
  }
  <!-- Opt-in: only a caller that sets `locationSummary` (the diary's remark
       cards) gets this line; report activities pass `location` and are
       unchanged. -->
  @if (data?.locationSummary) {
    <div class="location text-type-14 mt-[6px]" data-testid="activity-summary-location">
      <mat-icon class="location-icon" svgIcon="marker-outline" />
      <span class="location-text">{{ data?.locationSummary }}</span>
    </div>
  }
  @if (data?.map_feature_link?.sheet) {
    <!-- A linked sheet is a one-line chip on the tile; the record's side panel keeps the full card and Open sheet -->
    <app-design-context-chips [link]="data.map_feature_link" />
  } @else if (data?.map_feature_link) {
    <app-design-context class="card-design-context" [link]="data.map_feature_link" [editable]="false" [projectId]="projectId$ | async" />
  }
  @if (displayMatched) {
    <div
      class="matched text-type-15">{{ matchedNo }} {{ matchedNo > 1 ? 'occurrences' : 'occurrence' }}
    </div>
  }
</div>
